<template>
  <div>
    <h3 class="modal-title"> ANALYTIC </h3>

    <b-form-group :class="{'error-input' : $v.data_analytic.title.$error}">
      <label> Analytic Title </label>
      <j-input
        v-model="$v.data_analytic.title.$model"
        :max-length="255"
        placeholder="Analytic Title"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_analytic.analytic.$error}">
      <label> Select Analytic </label>
      <j-single-select
        v-model="$v.data_analytic.analytic.$model"
        :options="list_analytic"
        label="name"
        value-format="object"
        placeholder="Choose Analytic"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeAnalytic">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveAnalytic">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_analytic: {
      title: {
        required,
      },
      analytic: {
        required,
      },
    },
  },
  data() {
    return {
      data_analytic: {
        title: '',
        analytic: null,
      },
    };
  },
  computed: {
    ...mapState('jStoreApplication', ['list_analytic']),

    generateDataAnalytic() {
      const data = {
        value_id: `${this.data_analytic.analytic.id}`,
        pages_id: `${this.dataMaster.pages_id}`,
        name: this.data_analytic.title,
        component_master_id: this.dataMaster.id,
        info: JSON.stringify({
          id: this.data_analytic.analytic.id,
        }),
        type_platform: 1,
      };
      return data;
    },

    generateDataAnalyticUpdate() {
      const data = {
        value_id: `${this.data_analytic.analytic.id}`,
        pages_id: `${this.dataEdit.pages_id}`,
        name: this.data_analytic.title,
        order: this.dataEdit.order,
        component_master_id: this.dataMaster.id,
        info: JSON.stringify({
          id: this.data_analytic.analytic.id,
        }),
        type_platform: 1,
      };
      return data;
    },
  },
  mounted() {
    this.actionGetDashboardList();

    if (this.modeEdit) {
      this.actionGetDashboardList();
      this.data_analytic.title = this.dataEdit.name;
      this.data_analytic.analytic = {
        id: JSON.parse(this.dataEdit.info).id,
      };
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveComponent', 'updateComponent', 'actionGetDashboardList']),

    saveAnalytic() {
      this.$v.data_analytic.$touch();
      if (!this.$v.data_analytic.$error) {
        if (!this.modeEdit) {
          const dataParam = {
            data: this.generateDataAnalytic,
            id: this.dataMaster.id,
          };
          this.saveComponent(dataParam);
        } else {
          const dataParam = {
            data: this.generateDataAnalyticUpdate,
            id: this.dataMaster.id,
            component_id: this.dataEdit.id,
          };
          this.updateComponent(dataParam);
        }

        this.closeAnalytic();
      }
    },

    closeAnalytic() {
      this.$emit('close-field');
      this.data_analytic.title = '';
      this.data_analytic.analytic = null;
      setTimeout(() => {
        this.$v.data_analytic.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/pages-component/jAnalyticSetup.vue